import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import FormControls from 'component/FormControls';
import sendRequest, { sendPost, sendPut, sendDelete } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { formatDate, getString, nNU, showConfirm, showToast, formatMinutes, getParams } from 'util/utils';


const PcHistoryDetail = ({ data = { orderId: null } }) => {
    //-------------------------------HOOKS-------------------------------------------------------------
    const params = getParams();
    const currentUser = useSelector(selectCurrentUser);
    const orderId = data.orderId || params?.orderId;
    const [ selectedUser, setSelectedUser ] = useState(orderId);
    const [ dataUser, setDataUser ] = useState([])
    const [ page, setPage ] = useState(1);
    const [ total, setTotal ] = useState(0);
    const [ pageSize, setPageSize ] = useState(10);
    const isAdmin = useMemo(
        () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
        [ currentUser.accountRole ]
    );
    const [ searchId, setSearchId ] = useState('');
    const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);
    const history = useHistory();
    const formControls = [];
    const headers = [
        string.FINCODE_ORDER_ID,
        string.FINCODE_AMOUNT,
        string.FINCODE_STATUS,
        string.FINCODE_CREATED_AT,
    ]

    //------------------------------FUNCTIONS----------------------------------------------------------

    const doSearch = useCallback(async () => {
        try {
            let data = await sendRequest({
                url: `${Urls.fincode.orderdetail}/${selectedUser}`,
            });
            const { result } = data;
            setDataUser(result.orderDetails)
            return result;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [ selectedUser ]);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearchId(searchId);
        }, 500);

        return () => {
            clearTimeout(timerId);
        };
    }, [ searchId ]);


    useEffect(() => {
        doSearch(debouncedSearchId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ debouncedSearchId, doSearch ]);

    const dataTable = useCallback(
        (dataUser) =>
            dataUser.map((raw, key) => ({
                key: raw.id,
                data: [
                    raw.orderId,
                    raw.amount,
                    raw.status,
                    formatDate(raw.eventAt, 'YYYY-MM-DD HH:mm:ss'),
                ],
                raw,
            })),
        []
    );


    //-------------------------------RETURN------------------------------------------------------------
    return (
        <>
            <Page
                title={string.FINCODE_TITLE}
                body={
                    <>
                        <FormControls controls={formControls} />
                        <Table
                            className="nowrap"
                            page={page}
                            pageSize={pageSize}
                            total={total}
                            onPageChanged={setPage}
                            onPageSizeChanged={setPageSize}
                            headers={headers}
                            data={dataTable(dataUser)}
                            getCSVData={async () => {
                                return dataTable(await doSearch(1, total, null, true));
                            }}
                            csvFileName="AppUserList"
                            isPaging={true}
                            search={true}
                            onSearch={(value) => setSearchId(value)}
                            placeHolder={`${string.POC_LOGIN_ID},${string.POC_DISPLAY_NAME}`}
                        />
                    </>
                }
            />
        </>
    );
};
export default PcHistoryDetail;
